export { renderCompoundButton_unstable as renderCompoundButton } from '@fluentui/react-button';
